module.exports = __webpack_public_path__ + "static/media/icon5.086dc7f5.svg";